import { stringToGibberish } from "@faire/localization/core/gibberish";

const isPlaceholder = (segment: string): boolean =>
  segment.startsWith("{") && segment.endsWith("}");

/**
 * Applies Faire's gibberish pseudo-locale to playground copy so designers can
 * preview roughly how strings grow in translation. ICU placeholders like
 * `{name}` are preserved, matching production localization behavior.
 */
export const expandPlaygroundText = (text: string): string => {
  if (!text) {
    return text;
  }

  return text
    .split(/(\{[^}]+\})/)
    .map((segment) => {
      if (isPlaceholder(segment) || segment.length === 0) {
        return segment;
      }

      return stringToGibberish(segment);
    })
    .join("");
};
